import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Breadcrumbs,
  Grid,
  Typography,
} from "@material-ui/core";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import HomeStyles from "pages/HomeStyles";
import {
  setCurrentPage,
  getPhotoShootMapDataNtt,
  setPictreeMapType,
} from "actions";
import * as C from "components";
import PhotoShootMapNtt from "components/PicTree/Game/Map/PhotoShootMapNtt";
import SingleSelect from "components/Select/SingleSelect";
import CalendarRangePicTreeNtt from "components/Calendar/CalendarRangePicTreeNtt";

const useStyles = makeStyles((theme) =>
  createStyles({
    loaderBox: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 280,
    },
    loaderBarImg: {
      width: 40,
    },
    breadcrumbs: {
      marginTop: 16,
      minHeight: 30,
    },
    gridSection: {
      marginTop: theme.spacing(1),
    },
  })
);

const PicTreeMapNtt = ({
  currentPage,
  setCurrentPage,
  pageTopLoader,
  photoShootMapData,
  getPhotoShootMapDataNtt,
  setPictreeMapType,
  dateRangePicTreeNtt,
  selectedSeasonNtt,
}) => {
  const classes = useStyles();
  const [chartSize, setChartSize] = useState({ name: `レビューOK撮影+未撮影`, value: "taken+untaken" });
  const [photoType, setPhotoType] = useState("taken+untaken");
  const [initialDataCall, setInitialDataCall] = useState(true);
  const [layerVisibility, setLayerVisibility] = useState({ taken: true, untaken: true });
  const [layerOrder, setLayerOrder] = useState(["taken", "untaken"]);

  const isBoth = photoType === "taken+untaken";
  const takenCount   = (photoShootMapData?.[0]?.length) || 0;
  const untakenCount = (photoShootMapData?.[1]?.length) || 0;
  const total = takenCount + untakenCount;
  const ready = photoShootMapData.length > 0 && !pageTopLoader;

  const takenPct = total > 0 ? ((takenCount / total) * 100).toFixed(1) : "0.0";
  const untakenPct = total > 0 ? ((untakenCount / total) * 100).toFixed(1) : "0.0";

  useEffect(() => {
    setCurrentPage(window.location.pathname);
  }, []);

  useEffect(() => {
    if (
      dateRangePicTreeNtt[0] !== null &&
      dateRangePicTreeNtt[1] !== null &&
      initialDataCall
    ) {
      getPhotoShootMapDataNtt({type: "denchu", filter: "taken+untaken"});
      setInitialDataCall(false);
    }
  }, [dateRangePicTreeNtt]);

  const handleChange = (event) => {
    setChartSize(event.target);
    setPictreeMapType(event.target.value);
    setPhotoType(event.target.value);
    getPhotoShootMapDataNtt({type: "denchu", filter: event.target.value});
  };

  const handleLayerCheckboxChange = (kind) => (event) => {
    const checked = event.target.checked;
    setLayerVisibility((prev) => ({ ...prev, [kind]: checked }));
    setLayerOrder((prev) => {
      if (!checked) return prev.filter((item) => item !== kind);
      const withoutKind = prev.filter((item) => item !== kind);
      return [...withoutKind, kind];
    });
  };

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: -16, marginBottom: 8 }}
          justifyContent="space-between"
        >
          <Grid item>
            <Breadcrumbs separator="›" className={classes.breadcrumbs}>
              <Typography>PicTrée NTT ME</Typography>
              <Typography variant="body1">撮影</Typography>
              <Typography variant="body1">地図表示</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item className={classes.fillRemailSpace}></Grid>
          <Grid item>
            <CalendarRangePicTreeNtt
              mDate={"2024/12/7"}
              page="pictree-map"
              singlePeriod
            />
          </Grid>
        </Grid>

        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: 16, marginRight: 8, marginBottom: 8 }}
          justifyContent="flex-start"
        >
          <Grid item style={{ marginTop: 0, marginLeft: 8, }}>
            <SingleSelect
              selected={chartSize}
              options={[
                { name: `レビューOK撮影+未撮影`, value: "taken+untaken" },
                { name: `レビューOK撮影`, value: "taken" },
                { name: `未撮影`, value: "untaken" },
              ]}
              handleChange={handleChange}
            />
          </Grid>

          <Grid item>
          {isBoth ? (
            <Typography variant="subtitle1" style={{ marginTop: 10, marginLeft: 16 }}>
              <span style={{ display: "inline-flex", alignItems: "center", marginRight: 16 }}>
                <input
                  type="checkbox"
                  checked={layerVisibility.taken}
                  onChange={handleLayerCheckboxChange("taken")}
                  style={{ marginRight: 6 }}
                />
                <span
                  style={{
                    width: 10,
                    height: 10,
                    background: "#6e54a6",
                    borderRadius: "50%",
                    marginRight: 6,
                  }}
                />
                レビューOK撮影数：{ready ? takenCount.toLocaleString() : ""}
                {ready && total > 0 && (
                  <span style={{ marginLeft: 4 }}>（{takenPct}%）</span>
                )}
              </span>
              <span style={{ display: "inline-flex", alignItems: "center" }}>
                <input
                  type="checkbox"
                  checked={layerVisibility.untaken}
                  onChange={handleLayerCheckboxChange("untaken")}
                  style={{ marginRight: 6 }}
                />
                <span
                  style={{
                    width: 10,
                    height: 10,
                    background: "#f53b78",
                    borderRadius: "50%",
                    marginRight: 6,
                  }}
                />
                未撮影数：{ready ? untakenCount.toLocaleString() : ""}
                {ready && total > 0 && (
                  <span style={{ marginLeft: 4 }}>（{untakenPct}%）</span>
                )}
              </span>
            </Typography>
          ) : (
            <Typography variant="subtitle1" style={{ marginTop: 10, marginLeft: 16 }}>
              {photoType === "taken" ? "撮影数：" : "未撮影数："}
              {ready
                ? (photoType === "taken"
                    ? takenCount.toLocaleString()
                    : untakenCount.toLocaleString())
                : ""}
            </Typography>
          )}
        </Grid>

          <Grid item style={{paddingTop: 18, marginLeft: 16}}>
            <Typography variant="caption">
              {isBoth
                ? "※ クラスター内の%表示は「レビューOK撮影（済み）」の割合を示します。"
                : (photoType === "taken"
                    ? "* クラスター内の%表示はレビューOKレビューOK撮影総数に占める割合です"
                    : "* クラスター内の%表示は未撮影総数に占める割合です")}
            </Typography>
          </Grid>

        </Grid>

        {photoShootMapData.length > 0 &&
          <PhotoShootMapNtt
            records={
              photoType === "taken"   ? photoShootMapData[0]
            : photoType === "untaken" ? photoShootMapData[1]
            : [
                ...photoShootMapData[0].map(r => ({ ...r, __kind: "taken" })),
                ...photoShootMapData[1].map(r => ({ ...r, __kind: "untaken" })),
              ]
            }
            type="photoshoot"
            width="100%"
            height="85vh"
            status={chartSize === undefined ? "taken" : chartSize.value}
            seasonId={
              selectedSeasonNtt.length > 0
                ? selectedSeasonNtt[0]["seasonId"]
                : false
            }
            mapType={photoType}
            layerVisibility={layerVisibility}
            layerOrder={layerOrder}
          />
        }
        {photoShootMapData.length == 0 &&
          <PhotoShootMapNtt
            records={[]}
            type="photoshoot"
            width="100%"
            height="85vh"
            status="taken"
            seasonId={
              selectedSeasonNtt.length > 0
                ? selectedSeasonNtt[0]["seasonId"]
                : false
            }
            mapType={photoType}
            layerVisibility={layerVisibility}
            layerOrder={layerOrder}
          />
        }
      </C.ContentWrapper>
    </Fragment>
  );
};

PicTreeMapNtt.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  currentPage: state.page.currentPage,
  pageTopLoader: state.page.pageTopLoader,
  photoShootMapData: state.pictreeNtt.photoShootMapData,
  dateRangePicTreeNtt: state.page.dateRangePicTreeNtt,
  selectedSeasonNtt: state.pictreeNtt.selectedSeason,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getPhotoShootMapDataNtt: (param) => dispatch(getPhotoShootMapDataNtt(param)),
  setPictreeMapType: (param) => dispatch(setPictreeMapType(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(HomeStyles, { withTheme: true })(PicTreeMapNtt));
